import { ReactNode } from 'react';

import Box from 'shared_DEPRECATED/components/Box';
import { Flex } from 'shared_DEPRECATED/components/Flex';
import { Nullable } from 'shared_DEPRECATED/types';

import { Typography } from 'shared/components/Typography';

import { MenuRadioItem } from '../Menu';

type TDropdownMenuItem = {
  children: ReactNode;
  value: number | string;
  dataTestid?: Nullable<string>;
};

export const DropdownItem = ({
  children,
  value,
  dataTestid = null,
}: TDropdownMenuItem) => {
  return (
    <MenuRadioItem value={value} data-testid={dataTestid}>
      <Box style={{ maxWidth: '15rem' }}>
        <Flex alignItems="center" justifyContent="flex-start">
          <Typography type="meta" fontWeight="regular" color="black" cropped>
            {children}
          </Typography>
        </Flex>
      </Box>
    </MenuRadioItem>
  );
};
